<template>
  <div class="final-graph">
    <div
      v-if="finalDate"
      class="final-graph__date-wrapper"
    >
      <span
        :class="['final-graph__date-text paragraph-20-700', { 'final-graph__date-text--small': locale === 'de' }]"
      >
        {{ $t('final_adjustment_by_date', [finalDate]) }}
      </span>
      <VideoFallback
        v-show="isShowFasterLabel"
        src="video_34_faster.mp4"
        fallback-poster="video_34_faster.webp"
        :poster="getVideoLocaleUrl('video_34_faster_zaglushka.webp')"
        class="final-graph__video"
        localized
      />
    </div>
    <CNuxtImg
      class="final-graph__image"
      src="video_graph_final.webp"
      alt="final graph"
      min-height="190px"
      localize
    />
    <p
      v-if="label"
      class="final-graph__image-label paragraph-12-300"
      v-html="label"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  finalDate: String,
  label: String,
  fasterLabel: Boolean,
});
const { $versions } = useNuxtApp();
const { locale } = useI18n();
const { getVideoLocaleUrl } = useVideoLocaleUrl();

const isShowFasterLabel = computed(() => {
  return props.fasterLabel && $versions?.value.quiz !== '4' && $versions?.value.quiz !== '7';
});
</script>

<style lang="scss" scoped>
.final-graph {
  width: 100%;

  &__date-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    position: relative;
    min-height: 38px;
  }

  &__date-text {
    color: $blue;

    &--small {
      font-size: 18px;
    }
  }

  &__video {
    max-width: 90px;
    margin: 0;
  }

  &__image {
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
    margin-top: 23px;
    min-height: 190px;

    @media (min-width: 600px ) {
      max-width: 540px;
    }
  }

  &__image-label {
    margin-top: 12px;
    text-align: center;
    opacity: 0.5;
  }
}
</style>
